<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<span v-if="track">
  <i class="far fa-square color-preview" v-if="track.color" :style="{color: track.color}"></i>
  {{track.name}}
  <span class="term-text" v-if="currentUser.isDeveloper && track.id > 0"> ({{$t('id')}}: {{track.id}})</span>
</span>
</template>

<script>
import {get} from '@/utils/store-helpers';

export default {
  name: 'cytomine-track',
  props: {
    track: Object
  },
  computed: {
    currentUser: get('currentUser/user'),
  }
};
</script>

<style scoped>
  .color-preview {
    margin-right: 0.25em;
  }
  .term-text {
    color: #fff !important;
  }
</style>
